import { render, staticRenderFns } from "./IpAddressList.vue?vue&type=template&id=4a53252b&scoped=true"
import script from "./IpAddressList.vue?vue&type=script&lang=js"
export * from "./IpAddressList.vue?vue&type=script&lang=js"
import style0 from "./IpAddressList.vue?vue&type=style&index=0&id=4a53252b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a53252b",
  null
  
)

export default component.exports